import idx from "idx"

import { getSafeDataMap } from "@jsUtils"

/**
 * transform - manipulate data for tech specs
 * @param {object} specs - techspecs query
 * @returns {object}
 */

function transform(specs) {
  const techSpecs = specs
    ? specs.map(techSpec => {
        return {
          id: idx(techSpec, _ => _.id),
          title: idx(techSpec, _ => _.title),
          description: idx(techSpec, _ => _.description.childMarkdownRemark.html)
        }
      })
    : []
  return {
    techSpecs
  }
}

/**
 * transform a list for tech specs PAGE
 * @param {array} specs - array of specs from product specs
 * @returns {array}
 */
function transformList(specs) {
  const list = getSafeDataMap(specs, item => {
    const title = idx(item, _ => _.title)
    const id = idx(item, _ => _.id)
    const html = idx(item, _ => _.description.childMarkdownRemark.html)
    return {
      title,
      html,
      id
    }
  })
  return {
    items: list
  }
}

export default { transform, transformList }
